import React, { useMemo } from 'react'
import { BlockType, IFaqProp } from '../../../../types'
import { FAQJsonLd } from 'gatsby-plugin-next-seo'
import { jsonParseString } from '../../../../utils/string'

type Props = {
    blocks: BlockType[]
}
type Question = {
    question: string;
    answer: string;
}

export default function FAQSchema({ blocks }: Props) {

    // OF: this is dirty and unreadable but should work
    // wrapped in try catch to prevent errors
    const questions = useMemo(() => {
        try {
            const fields = blocks.map(block => block.attributes).flat();
            const faqFields = fields.filter(field => field.fieldId === 'faq');
            return faqFields.map(field => {
                const data = JSON.parse(field?.value || "{}")?.value as (IFaqProp | null);
                const faqs = data?.faqs;
                if (!faqs) return null;
                return faqs.map(faq => {
                    let data = jsonParseString(faq.data);
                    if (!data.Question || !data.Answer) return null;
                    return {
                        question: data.Question as string,
                        answer: data.Answer as string
                    }
                })
            }).flat().filter(Boolean) as Question[];
        } catch (e) {
            console.error(e)
            return []
        }
    }, [blocks])

    console.log(11, questions)

    if (questions.length === 0) return null;

    return (
        <FAQJsonLd
            questions={questions}
        />
    )
}
